import { render, staticRenderFns } from "./DatepickerField.vue?vue&type=template&id=56a8338e&"
import script from "./DatepickerField.vue?vue&type=script&lang=ts&"
export * from "./DatepickerField.vue?vue&type=script&lang=ts&"
import style0 from "./DatepickerField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports